import { apiRequest } from "../util/apiUtils";

export const chatCreate = async (payload) => {
  try {
    const res = await apiRequest("post", `communication-group/add`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const chatMessageSend = async (payload, uploadPercentage = () => {}) => {
  try {
    const res = await apiRequest(
      "post",
      `communication/add`,
      {
        body: payload,
      },
      "multipart/form-data",
      uploadPercentage
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const chatDetails = async (params) => {
  try {
    const res = await apiRequest(
      "get",
      `communication-group/detail/${params?.id}`,
      {
        queries: params?.type && { type: params?.type },
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const chatLists = async (params) => {
  try {
    const res = await apiRequest("get", `communication-group/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const messageList = async (params) => {
  try {
    const res = await apiRequest("get", `communication/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const messageSeen = async (params) => {
  try {
    const res = await apiRequest("patch", `communication/seen`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
